import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "MaintenancePlanListPage" */
	'pages/vehicle/MaintenancePlan/MaintenancePlanListPage'));

export default [{ component, exact: true, path: '/maintenance_plans' }];